const styles = (theme) => ({
  selectField: {
    width: '150px',
    marginRight: '12px',
  },
})

export default styles
